import { Button, PageHeader } from 'components';
import { Row, Col, Typography, Spin } from 'antd';
import styles from './style.module.scss';
import { useTranslation } from 'react-i18next';
import useInterviewStorePools from '../useInterviewStorePools';
import { ResponsivePie } from '@nivo/pie';
import { ExcelIcon } from 'icons';
import moment from 'moment';

const colors = ['#1f77b4', '#f47560', '#e8a838', '#2ca02c'];

const Results = () => {
  const { t } = useTranslation();

  const { singleItem, handleDownloadExcelSingle, loading } =
    useInterviewStorePools(false, false);
  const chartData = singleItem?.allData?.chart || [];
  const data = chartData.map((i, index) => ({
    id: i[0],
    label: i[0],
    value: i[1],
    color: colors[index],
  }));
  return (
    <div>
      <PageHeader title={t('RISULTATI VOTA BEST STORE')}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              onClick={handleDownloadExcelSingle}
              loading={loading}
            >
              {t('Export')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.content}>
        <Spin spinning={loading}>
          <Row>
            <Col span={24}>
              <Typography.Title level={4}>{singleItem?.title}</Typography.Title>
              <p>
                DAL <b>{moment(singleItem.date_from).format('DD MMMM YYYY')}</b>{' '}
                AL <b>{moment(singleItem.date_to).format('DD MMMM YYYY')}</b>
              </p>
            </Col>
            <Col span={24} className={styles.chart}>
              <ResponsivePie
                data={data}
                colors={({ id, data }) => String(data.color)}
                margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
                innerRadius={0.5}
                padAngle={0.7}
                cornerRadius={3}
                activeOuterRadiusOffset={8}
                borderWidth={1}
                borderColor={{
                  from: 'color',
                  modifiers: [['darker', 0.2]],
                }}
                arcLinkLabelsSkipAngle={10}
                arcLinkLabelsTextColor='#333333'
                arcLinkLabelsThickness={2}
                arcLinkLabelsColor={{ from: 'color' }}
                arcLabelsSkipAngle={10}
                arcLabelsTextColor={{
                  from: 'color',
                  modifiers: [['darker', 2]],
                }}
                defs={[
                  {
                    id: 'dots',
                    type: 'patternDots',
                    background: 'inherit',
                    color: 'rgba(255, 255, 255, 0.3)',
                    size: 4,
                    padding: 1,
                    stagger: true,
                  },
                  {
                    id: 'lines',
                    type: 'patternLines',
                    background: 'inherit',
                    color: 'rgba(255, 255, 255, 0.3)',
                    rotation: -45,
                    lineWidth: 6,
                    spacing: 10,
                  },
                ]}
                fill={[
                  {
                    match: {
                      id: 'ruby',
                    },
                    id: 'dots',
                  },
                  {
                    match: {
                      id: 'c',
                    },
                    id: 'dots',
                  },
                  {
                    match: {
                      id: 'go',
                    },
                    id: 'dots',
                  },
                  {
                    match: {
                      id: 'python',
                    },
                    id: 'dots',
                  },
                  {
                    match: {
                      id: 'scala',
                    },
                    id: 'lines',
                  },
                  {
                    match: {
                      id: 'lisp',
                    },
                    id: 'lines',
                  },
                  {
                    match: {
                      id: 'elixir',
                    },
                    id: 'lines',
                  },
                  {
                    match: {
                      id: 'javascript',
                    },
                    id: 'lines',
                  },
                ]}
                legends={[
                  {
                    anchor: 'bottom',
                    direction: 'row',
                    justify: false,
                    translateX: 0,
                    translateY: 56,
                    itemsSpacing: 0,
                    itemWidth: 200,
                    itemHeight: 18,
                    itemTextColor: '#999',
                    itemDirection: 'left-to-right',
                    itemOpacity: 1,
                    symbolSize: 18,
                    symbolShape: 'circle',
                    effects: [
                      {
                        on: 'hover',
                        style: {
                          itemTextColor: '#000',
                        },
                      },
                    ],
                  },
                ]}
              />
            </Col>
          </Row>
        </Spin>
      </div>
    </div>
  );
};

export default Results;
